

<div class="composite-design-proj-building">
    <div id="flatOffer" *ngIf="offer">
        <!-- <div *ngFor="let flat of offer.flatsArray" class="flat-menu">
                <button (click)="removeFlatFromView(flat)">remove flat</button>
                <a href="javascript:;" (click)='editItem($event, flat)'
                    class="btn"><span>קומה:</span>{{
                    flat.floorNumber }} <span>מספר
                        חדרים:</span>{{ flat.numberOfRooms }} <span>שטח הדירה:</span>{{ flat.flatSize }}</a>
            </div> -->
          
        <div *ngFor="let flat of offer.flatsArray" class="buildings-holder">
            <app-offer-flat-properties [offer]="offer" [buildingUid]="flat.buildingUid" [flatId]="flat.id" class="show-flat-properties">
            </app-offer-flat-properties>
        </div>
    </div>

    <div class="projects" *ngIf="proj?.length > 0">
        <div class="col m12 iframe da-iframe" [innerHtml]="proj[0].spirical | safe: 'html'">
        </div>
        <app-gallery [galleryId]="'1'" [section]="compId+'logo-project-up'" [autoPlay]="false" [showThumbs]="false"
            class="slogan-img slogan-img-project-up"></app-gallery>
        <app-gallery [galleryId]="'1'" [section]="proj[0].id+'logo-project-down'" [autoPlay]="false"
            [showThumbs]="false" class="slogan-img slogan-img-project-down"></app-gallery>
        <!-- <app-gallery (click)="openFake3d()" [galleryId]="'1'" [section]="item.id+'logo-project-right-down'"
                [autoPlay]="false" [showThumbs]="false" style="display: block;"
                class="slogan-img slogan-img-project-right-down">
            </app-gallery> -->
        <app-gallery [galleryId]="'1'" [section]="proj[0].id+'logo-project-left-top'" [autoPlay]="false"
            [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
        </app-gallery>
        <app-gallery [galleryId]="'1'" [section]="proj[0].id+'editional-gallery'" [autoPlay]="false"
            [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
        </app-gallery>
    </div>
</div>